module.exports = __webpack_public_path__ + "img/sh.487ef1c8.svg";